export default {
  name: 'BannerList',

  data() {
    return {
      allCards: [],
      // 所有卡片数据
      computedCards: [],
      frontIndex: 0,
      // 当前最前面卡片在 allCards 中的索引
      visibleCount: 10,
      // 前排可见的卡片数
      autoPlayTimer: null
    };
  },

  async mounted() {
    await this.fetchCards();
    this.updateCardsPosition();
    this.startAutoPlay();
    this.initZhsHelper(); // Resize listener for responsive centering

    window.addEventListener('resize', this.updateCardsPosition);
  },

  beforeUnmount() {
    this.stopAutoPlay();
    window.removeEventListener('resize', this.updateCardsPosition);
  },

  methods: {
    async fetchCards() {
      try {
        const res = await this.$http.listMajorSubject({
          num: 100
        });

        if (res && Array.isArray(res)) {
          const list = Array.isArray(res) ? res : res.data || [];
          this.allCards = list.map((item, index) => ({
            id: item.classify_id || index,
            classifyId: item.classify_id || '',
            organId: item.organ_id || '',
            title: item.classify_name || '',
            desc: item.organ_name || '',
            ts: 22,
            ds: 14,
            color: '#0E3FDF',
            bg: '#FFFFFF'
          }));
        }
      } catch (e) {
        console.error('获取专业学科列表失败', e);
      }
    },

    // 获取轨道上所有卡片
    getVisibleCards() {
      const total = this.allCards.length;
      if (total === 0) return [];
      const half = Math.floor(total / 2);
      const cards = [];

      for (let offset = -half; offset <= half; offset++) {
        const dataIndex = ((this.frontIndex + offset) % total + total) % total;
        cards.push({ ...this.allCards[dataIndex],
          _dataIndex: dataIndex,
          _offset: offset
        });
      }

      return cards;
    },

    updateCardsPosition() {
      const bannerEl = this.$el;
      if (!bannerEl) return;
      const viewW = bannerEl.offsetWidth;
      const viewH = bannerEl.offsetHeight;
      const ratio = Math.min(viewW / 1440, 1);
      const a = 350 * ratio; // 椭圆水平半径

      const b = 90 * ratio; // 椭圆垂直半径

      const centerX = 1440 / 2;
      const centerY = viewH * 0.5;
      const visibleCards = this.getVisibleCards();
      if (visibleCards.length === 0) return;
      const baseW = 190 * ratio;
      const baseH = 140 * ratio;
      const activeH = 190 * ratio;
      const visibleHalf = Math.floor(this.visibleCount / 2);
      this.computedCards = visibleCards.map(card => {
        const offset = card._offset;
        const isHidden = Math.abs(offset) > visibleHalf; // 可见卡片：按 visibleCount 均匀分布在椭圆前半部分
        // 隐藏卡片：全部放在最后面（顶部）

        let angle, depth, cosA, sinA;

        if (!isHidden) {
          // 可见卡片分布范围更大，减小后面缺口
          const angleRange = Math.PI * 2.0;
          angle = Math.PI / 2 + -offset * (angleRange / this.visibleCount);
          cosA = Math.cos(angle);
          sinA = Math.sin(angle);
          depth = (1 - sinA) / 2;
        } else {
          // 隐藏卡片都在最后面
          angle = -Math.PI / 2; // 顶部

          cosA = 0;
          sinA = -1;
          depth = 1;
        }

        const perspScale = 1 - depth * 0.55;
        const w = baseW * perspScale;
        const h = baseH * perspScale;
        const zIndex = Math.round((1 - depth) * 20); // 位置用固定椭圆半径，不受透视缩放影响，间距更均匀

        const targetX = centerX + cosA * a - w / 2;
        const targetY = centerY + sinA * b - h / 2 + depth * (-80 * ratio);
        const rotateY = -cosA * 45 * depth;
        const transformOrigin = 'center center';
        const rotateXTilt = 0;
        const scaleRatio = w / baseW;
        const standardTs = 22 * ratio * scaleRatio;
        const standardDs = 14 * ratio * scaleRatio;
        const isActive = offset === 0;
        const r = 16 * ratio * perspScale; // 最里面的可见卡片 (offset = ±5) 也设为透明

        const isBackEdge = Math.abs(offset) === visibleHalf;
        const op = isHidden || isBackEdge ? 0 : 1 - depth * 0.5;
        return { ...card,
          w: isActive ? baseW : w,
          h: isActive ? activeH : h,
          op,
          r,
          zIndex: isActive ? 30 : zIndex,
          scale: isActive ? 1.1 : undefined,
          ts: standardTs,
          ds: standardDs,
          x: targetX,
          y: isActive ? centerY + 60 * ratio : targetY,
          active: isActive,
          bg: '#FFFFFF',
          color: isActive ? '#FFFFFF' : depth < 0.85 ? '#0E3FDF' : '#86909C',
          rotateY,
          rotateXTilt,
          transformOrigin
        };
      });
    },

    rotateCards(direction) {
      const total = this.allCards.length;
      if (total === 0) return;

      if (direction === 'next') {
        this.frontIndex = (this.frontIndex + 1) % total;
      } else {
        this.frontIndex = (this.frontIndex - 1 + total) % total;
      }

      this.updateCardsPosition();
    },

    startAutoPlay(immediate = false) {
      this.stopAutoPlay();
      if (immediate) this.rotateCards('next');
      this.autoPlayTimer = setInterval(() => {
        this.rotateCards('next');
      }, 3000);
    },

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },

    handleCardLeave(e) {
      if (e.relatedTarget && e.relatedTarget.closest('.floating-card')) return;
      this.startAutoPlay(true);
    },

    goToCourseList(card) {
      const classifyId = card.classifyId || '';
      const organId = card.organId || '';
      window.location.href = `courseList.html?menuId=1920393738371338240&name=课程云&roleType=0,1,2,3&type=1&classifyId=${classifyId}&organId=${organId}`;
    },

    handleCardClick(index) {
      const card = this.computedCards[index];
      if (!card || card.active) return;
      const total = this.allCards.length; // 根据点击卡片的偏移量更新 frontIndex

      this.frontIndex = ((this.frontIndex + card._offset) % total + total) % total;
      this.updateCardsPosition();
      this.startAutoPlay();
    },

    getQuoteColor(card) {
      if (card.active) return 'rgba(255, 255, 255, 0.2)';
      if (card.color === '#0E3FDF') return 'rgba(14, 63, 223, 0.2)';
      return 'rgba(134, 144, 156, 0.2)';
    },

    loadJs(src, flag = false) {
      return new Promise((resolve, reject) => {
        let script = document.querySelector(`[src='${src}']`);

        if (script) {
          resolve(null);
        } else {
          script = document.createElement('script');
          script.type = 'text/javascript';

          if (flag) {
            script.id = 'zhs_tool_chat';
            script.setAttribute('elementZHsId', 'sdauHelper');
            script.setAttribute('version', '1.0.0');
          }

          script.src = src;
          document.querySelector('head').append(script);
          script.addEventListener('load', () => resolve(null));
          script.addEventListener('error', () => reject());
        }
      });
    },

    async initZhsHelper() {
      const style = document.createElement('style');
      style.innerHTML = '.mianDrawerZhs{top:80px!important;height:calc(100% - 80px)!important;} .header-icon{width:25px!important;height:25px!important;}';
      document.head.appendChild(style);
      await this.loadJs('https://resources.polymas.com/common/loadVuePluginNpm.js', true);
      await this.loadJs('https://base1.zhihuishu.com/able-commons/resources/uploader/client/js/jquery/jquery-1.7.2.min.js');
      new ZhsAiToolHelperCommon('meTXJPTa0N', {
        ipStyles: {
          mainColor: '#0E3FDF',
          toolIpIcon: 'https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/oukTlR_OqJBj7/69c26c32e4b023103af30448.png',
          toolIpIconStyle: {
            position: 'absolute',
            top: 'auto',
            bottom: '-2.6rem',
            right: '0rem',
            left: 'auto',
            zIndex: 10000,
            width: '351px',
            height: '372px'
          },
          ipIcon: 'https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/oukTlR_OqJBj7/69c24face4b023103af2f42a.png',
          ipIconStyle: {
            width: '92px',
            right: '20px',
            marginBottom: '-20px'
          }
        },
        disDrag: true
      });
    }

  }
};